import React from 'react';
import { Box, Typography, Stack, TextField } from '@mui/material';
import type { InsuranceType } from '../../../../../../services/EncounterService/types/encounterTypes';

interface PolicyInfoSectionProps {
  policyNumber: string;
  groupNumber: string;
  groupName: string;
  isDisabled: boolean;
  onInputChange: (field: keyof InsuranceType, value: string) => void;
}

export const PolicyInfoSection: React.FC<PolicyInfoSectionProps> = ({
  policyNumber,
  groupNumber,
  groupName,
  isDisabled,
  onInputChange
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Policy Information
      </Typography>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <TextField
            label="Policy Number"
            size="small"
            value={policyNumber}
            onChange={(e) => onInputChange('policyNumber', e.target.value)}
            disabled={isDisabled}
            sx={{
              flex: 1,
              '& .MuiInputBase-input': {
                backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
              }
            }}
            required
            helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
          />
          <TextField
            label="Group Number"
            size="small"
            value={groupNumber}
            onChange={(e) => onInputChange('groupNumber', e.target.value)}
            disabled={isDisabled}
            sx={{
              flex: 1,
              '& .MuiInputBase-input': {
                backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
              }
            }}
            helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
          />
          <TextField
            label="Group Name"
            size="small"
            value={groupName}
            onChange={(e) => onInputChange('groupName', e.target.value)}
            disabled={isDisabled}
            sx={{
              flex: 1,
              '& .MuiInputBase-input': {
                backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
              }
            }}
            helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
          />
        </Stack>
      </Stack>
    </Box>
  );
};
